import React, { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { TopHeader } from "@root/components/DashboardTopHeader/topheader";
import Header from "./header";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import CategoryTabs from "./dashboardtabs";
import { StatsCards } from "@root/components/stat-cards/statcards";

export const DashboardPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showReports, setShowReports] = useState(false);
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  function handleViewAll(): void {
    setShowReports(true);
  }

  const formatName = (name: string) =>
    name?.charAt(0)?.toUpperCase() + name?.slice(1);

  return (
    <Box height={"100%"} display={"flex"} flexDirection={"column"}>
      <Box padding="24px" flex={1} display="flex" flexDirection="column">
        <Header name={formatName(isLoggedInUser?.fullname)} />
        <StatsCards />
        <Box flex={1}>
          <CategoryTabs />
        </Box>
      </Box>
    </Box>
  );
};
